import { render, staticRenderFns } from "./cuentas-corrientes.vue?vue&type=template&id=5da10b78&scoped=true"
import script from "./cuentas-corrientes.vue?vue&type=script&lang=js"
export * from "./cuentas-corrientes.vue?vue&type=script&lang=js"
import style0 from "./cuentas-corrientes.vue?vue&type=style&index=0&id=5da10b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da10b78",
  null
  
)

export default component.exports